import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faTrash, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';
import Navbar from '../Navbar/Navbar';
import imagen from '../../images/staticas/vender-tu-auto-1.png';
import { Link } from 'react-router-dom'; // Asegurate de tener esto en los imports


export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10];
    const [categorias, setCategorias] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();

    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();
        cargarMarcas();
        cargarModelos();
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }
    }, []);

    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // CORRECCIÓN: Se cambia de data.marcas a data.marca
                setMarcas(data.marca || []);
            })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    const cargarModelos = () => {
        fetch(`${baseURL}/modelosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setModelos(data.modelos || []);
            })
            .catch(error => console.error('Error al cargar modelos:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
                setLoading(true);
            });
    };

    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .then(() => console.log('Contenido compartido correctamente'))
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = contactos?.telefono;
        const nombreConcesionaria = 'IDO';

        // Recopila los datos del vehículo disponibles
        const datosVehiculo = [
            `*Vehículo:* ${producto?.titulo || 'No especificado'}`,
            producto?.anio && `*Año:* ${producto.anio}`,
            producto?.kilometros && `*Kilómetros:* ${producto.kilometros}`,
            producto?.transmision && `*Transmisión:* ${producto.transmision}`,
            producto?.combustible && `*Combustible:* ${producto.combustible}`,
            producto?.precio && `*Precio:* ${moneda} ${String(producto.precio).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
        ].filter(Boolean).join('\n'); // Filtra los valores nulos o indefinidos y une el resto

        const message = `¡Hola, equipo de ${nombreConcesionaria}! 👋\n\nEstoy interesado en uno de sus vehículos y me gustaría obtener más información.\n\nAquí los detalles:\n${datosVehiculo}\n\nGracias, espero su pronta respuesta. 😊`;
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };

    const addToCart = (selectedItem) => {
        if (producto) {
            if (producto.stock < 1) {
                toast.error('No hay stock', { autoClose: 400 });
                return;
            }
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const existingItemIndex = cart.findIndex(item =>
                item.idProducto === producto.idProducto
            );
            if (existingItemIndex !== -1) {
                const existingItem = cart[existingItemIndex];
                const updatedSabores = [...existingItem.item, selectedItem];
                const updatedCantidad = existingItem.cantidad + cantidad;
                cart[existingItemIndex] = { ...existingItem, item: updatedSabores, cantidad: updatedCantidad };
            } else {
                cart.push({ idProducto: producto.idProducto, item: [selectedItem], cantidad });
            }
            localStorage.setItem('cart', JSON.stringify(cart));
            cargarProductos();
            toast.success('Producto agregado', { autoClose: 400 });
            setTimeout(() => {
                window.location.reload();
            }, 600);
        }
    };

    const incrementCantidad = () => {
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };

    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto agregado a favoritos');
        } else {
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto eliminado de favoritos');
        }
    };

    // Lógica para obtener el nombre de la categoría y la marca
    const categoriaNombre = categorias.find(cat => cat.idCategoria === producto?.idCategoria)?.categoria;

    // CORRECCIÓN: Se busca la marca directamente usando el idMarca del producto
    const marcaNombre = marcas.find(marca => marca.idMarca === producto?.idMarca)?.nombre;

    const motoFields = {
        'engine': 'Motor',
        'width': 'Ancho',
        'cooling': 'Enfriamiento',
        'height': 'Altura',
        'fuel': 'Combustible',
        'seatHeight': 'Altura del asiento',
        'displacement': 'Desplazamiento',
        'frontWheel': 'Rueda delantera',
        'maxPower': 'Máxima potencia',
        'rearWheel': 'Rueda trasera',
        'maxSpeed': 'Velocidad máxima',
        'frontBrake': 'Freno delantero',
        'rearBrake': 'Freno trasero',
        'starter': 'Arrancadora',
        'tank': 'Tanque',
        'weight': 'Peso',
        'alarm': 'Alarma',
        'length': 'Longitud',
        'warranty': 'Garantía',
    };

    if (!producto || loading) {
        return <DetailLoading />;
    }

    return (
        <div className="detail">
            <Navbar />
            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                <div className="deFLexIcon">
                    {/*<button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>*/}
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>
            </div>
            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"} >
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true, }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                    >
                        {
                            producto.imagen1 && (
                                <SwiperSlide>
                                    <img
                                        src={producto.imagen1}
                                        alt={producto.titulo}
                                        className="imagen1"
                                        onClick={() => {
                                            setModalImage(producto.imagen1);
                                            setIsModalOpen(true);
                                        }}
                                    />
                                </SwiperSlide>
                            )
                        }
                        {
                            producto.imagen2 && (
                                <SwiperSlide>
                                    <img
                                        src={producto.imagen2}
                                        alt={producto.titulo}
                                        className="imagen2"
                                        onClick={() => {
                                            setModalImage(producto.imagen2);
                                            setIsModalOpen(true);
                                        }}
                                    />
                                </SwiperSlide>
                            )
                        }
                        {
                            producto.imagen3 && (
                                <SwiperSlide>
                                    <img
                                        src={producto.imagen3}
                                        alt={producto.titulo}
                                        className="img"
                                        onClick={() => {
                                            setModalImage(producto.imagen3);
                                            setIsModalOpen(true);
                                        }}
                                    />
                                </SwiperSlide>
                            )
                        }
                        {
                            producto.imagen4 && (
                                <SwiperSlide>
                                    <img
                                        src={producto.imagen4}
                                        alt={producto.titulo}
                                        className="imagen4"
                                        onClick={() => {
                                            setModalImage(producto.imagen4);
                                            setIsModalOpen(true);
                                        }}
                                    />
                                </SwiperSlide>
                            )
                        }
                    </Swiper>
                </SwiperSlide>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className='price-section'>
                        {producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined && (
                            <h5 className='precio-tachado'>{moneda} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>

                        )}
                        <h5 className="price-current">
                            {moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </h5>
                    </div>
                    {/* Sección de datos del vehículo */}
                    <div className="product-details-grid">
                        {categoriaNombre && <p><b>Categoría:</b> {categoriaNombre}</p>}
                        {marcaNombre && <p><b>Marca:</b> {marcaNombre}</p>}
                        {producto?.modelo && <p><b>Modelo:</b> {producto.modelo}</p>}
                        {producto?.anio && <p><b>Año:</b> {producto.anio}</p>}
                        {producto?.kilometros && <p><b>Kilómetros:</b> {producto.kilometros}</p>}
                        {producto?.transmision && <p><b>Transmisión:</b> {producto.transmision}</p>}
                        {producto?.combustible && <p><b>Combustible:</b> {producto.combustible}</p>}

                        {producto.isMotorcycle ? (
                            Object.entries(motoFields).map(([key, label]) => {
                                const value = producto[key];
                                if (!value) return null; // skip empty or undefined values

                                return (
                                    <p key={key}><b>{label}:</b> {value} </p>
                                );
                            })
                        ) : null}
                    </div>

                    <p>{producto.descripcion}</p>
                    <div className='itemsDetail'>
                        {producto && items.length > 0 && items.map((item, index) => (
                            item && (
                                <label key={index}>
                                    <input
                                        type="radio"
                                        name="talle"
                                        value={item}
                                        checked={selectedItemIndex === index}
                                        onChange={() => handleSelectionChange(index)}
                                    />
                                    {item}
                                </label>
                            )
                        ))}
                    </div>
                    <div className='deFlexGoTocart'>
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            Quiero mas informacion
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>

                    </div>



                </div>

            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
            {/* NUEVA SECCIÓN: Vende tu auto + mapa */}
            <br />
            <br />
            <div className="vende-mapa-wrapper">
                <div className="vende-auto">
                    <img src={imagen} alt="Auto en venta" className="img-fondo" />
                    <div className="vende-contenido">
                        <br />
                        <br />
                        <h3>SUMATE A IDO</h3>
                        <p>Consecionario oficial Subaru y Suzuki</p>
                    </div>
                </div>


                <div className="mapa-container">
                    <iframe
                        className="google-map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3382.123456789!2d-63.912345!3d-32.274567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94322f123456789%3A0xabcdef123456789!2sSan%20Mart%C3%ADn%2088%2C%20Oncativo%2C%20C%C3%B3rdoba!5e0!3m2!1ses!2sar!4v1234567890"
                        allowFullScreen
                        loading="lazy"
                        style={{ width: '100%', height: '500px', border: 0 }}
                    ></iframe>
                </div>

            </div>
        </div >
    )
}